export enum Role {
  Student = "student", // Alternant
  Trainer = "trainer", // Intervenant pédagogique
  Administrator = "administrator", // Administrateur
  TrainingPartner = "training_partner", // Maître d'apprentissage
  StudiesDirector = "studies_director", // Responsable pédagogique
  PortalUser = "portal_user",
}
